
import React, { Suspense, useEffect, useRef, useState } from 'react'
// import Header from "../components/Header";
import Form from "../components/Form";
// import Calculator from "../components/Calculator";
// import Glnetwork from "../components/Glnetwork";
// import Availgl from "../components/Availgl";
// import Solution from "../components/Solution";
// import Faq from "../components/Faq";
import { lazy } from 'react';

const Calculator = lazy(() => import("../components/Calculator.js"));
const Availgl = lazy(() => import("../components/Availgl.js"));
const Solution = lazy(() => import("../components/Solution.js"));
const Faq = lazy(() => import("../components/Faq.js"));
const Glnetwork = lazy(() => import("../components/Glnetwork.js"));

function Homepage() {
  const [executed, setExecuted] = useState(false);
  const [syncADL, setSyncADL] = useState(0);
  const [loadDeferredSections, setLoadDeferredSections] = useState(false);
  const deferredSectionsRef = useRef(null);

  useEffect(() => {
    const deferredSections = deferredSectionsRef.current;

    if (!deferredSections) return undefined;

    // PERF-OPT-2026-09-05: Load below-the-fold sections shortly before they enter the viewport.
    // Browsers without IntersectionObserver keep the previous eager-loading behaviour.
    if (!("IntersectionObserver" in window)) {
      setLoadDeferredSections(true);
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setLoadDeferredSections(true);
        observer.disconnect();
      }
    }, { rootMargin: "200px 0px" });

    observer.observe(deferredSections);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!executed) {
      window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
            event: 'gold_loan_index_page',
        });
        // console.log("dataLayer", window.dataLayer);
        setExecuted(true);
    }
    
}, []);

  return (
    <>

      {/* <Header /> */}
      {/* PERF-OPT-2026-08-28: Original Suspense placement retained for rollback.
      <Suspense fallback={<>Loading...</>}>
      */}
      {/* PERF-OPT-2026-08-28: Keep the above-the-fold Form and LCP banner outside the lazy boundary so they can render immediately. */}
      <Form />

      {/* Disclaimer Section */}
      <article className="disclaimer_banner_sec" style={{ padding: '20px 0' }}>
        <div className="container">
          <div className="disclaimer_sec" style={{ fontSize: '12px', color: '#000000' }}>
            <h6 style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '4px', color: '#000000' }}>Minimum Loan Amount:</h6>
            <ul style={{ paddingLeft: '25px', marginBottom: '0', listStyleType: 'disc' }}>
              <li style={{ display: 'list-item', listStyleType: 'disc' }}>₹ 3 lakh for 'New to Bank' customers (i.e., customers who do not have an existing relationship with ICICI Bank), in metro locations</li>
              <li style={{ display: 'list-item', listStyleType: 'disc' }}>₹ 2 lakh for 'New to Bank' customers (i.e., customers who do not have an existing relationship with ICICI Bank), in non-metro locations</li>
            </ul>
          </div>
        </div>
      </article>

      <div ref={deferredSectionsRef} aria-hidden="true" />

      {/* PERF-OPT-2026-09-05: Original eager-loading block retained for rollback.
      <Suspense fallback={null}>
        <Calculator syncADL={syncADL} />
        <Glnetwork />
        <Availgl />
        <Solution />
        <Faq setSyncADL={setSyncADL} syncADL={syncADL} />
      </Suspense>
      */}

      {/* PERF-OPT-2026-09-05: Previously this Suspense block mounted immediately, so every lazy chunk
          was still requested during the initial page load. It now mounts near the viewport. */}
      {loadDeferredSections && (
        <Suspense fallback={null}>
          <Calculator syncADL={syncADL} />
          <Glnetwork />
          <Availgl />
          <Solution />
          <Faq setSyncADL={setSyncADL} syncADL={syncADL} />
        </Suspense>
      )}

    </>
  );
}

export default Homepage;
